import { useState } from 'react'
import MarkdownRenderer from '@/components/ChatResponseElements/MarkdownRenderer'
import { isResponseBlockInferenceEnabled } from '@/config/env/responseUi.js'
import Phase1InferredText from './Phase1InferredText'

/**
 * Stay on the live markdown renderer after a stream so inferred cards cannot
 * remount (and re-animate) the answer that just finished typing.
 */
export default function Phase1MarkdownOrInferred({ text, citations, streaming }) {
  const [streamed, setStreamed] = useState(streaming)
  if (streaming && !streamed) setStreamed(true)
  if (streaming || streamed || !isResponseBlockInferenceEnabled()) {
    return <MarkdownRenderer text={text} citations={citations} streaming={streaming} />
  }
  return <Phase1InferredText text={text} citations={citations} />
}
